import React from 'react';

import FadeIn from 'src/components/elements/FadeIn/FadeIn';

import { S3_MP4_URL } from '../../constants';

import styles from './SolarCashUsage.scss';

const SolarCashUsage = () => (
  <div className={styles.solarCashUsage}>
    <div className={styles.textWrapper}>
      <div className={styles.title}>
        <FadeIn delay={0.2}>
          Easy <span className={styles.titleThin}>to spend</span>
        </FadeIn>
      </div>
      <div className={styles.description}>
        <FadeIn delay={0.4}>
          Use your Solar Cash bonuses
          <br />
          when you pay
        </FadeIn>
      </div>
    </div>
    <div className={styles.videoWrapper}>
      <video
        autoPlay={true}
        preload="auto"
        loop={true}
        muted={true}
        playsInline={true}
        className={styles.video}
      >
        <source src={`${S3_MP4_URL}solar_cash_usage.mp4`} type="video/mp4" />
      </video>
    </div>
  </div>
);

export default SolarCashUsage;
